import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingUrlPublic, getNonprofitsUrlPublic, getOperationsSupportedApplicationsUrl, getOperationsUrlPublic, getProductAndServicesUrlPublic, getSalesUrlPublic, getServiceUrlPublic, getStartupsUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { NavItemEnum } from '../routing/NavItems';
export const FaqsConfig = {
  [NavItemEnum.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'marketing.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.SALES]: [{
    questionKey: 'sales.whatIsSalesHub411',
    getHref: () => getSalesUrlPublic()
  }, {
    questionKey: 'sales.whatIsFreeVsPaid411'
  }, {
    questionKey: 'sales.howManyUsers411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'sales.salesVsService411'
  }, {
    questionKey: 'sales.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'sales.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.SERVICE]: [{
    questionKey: 'service.whatIsServiceHub411',
    getHref: () => getServiceUrlPublic()
  }, {
    questionKey: 'service.whatIsFreeVsPaid411'
  }, {
    questionKey: 'service.howManyUsers411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'service.salesVsService411'
  }, {
    questionKey: 'service.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'service.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.CMS]: [{
    questionKey: 'cmsHub.whatIsCMSHub411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'cmsHub.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'cmsHub.whatLimits411',
    getHref: () => getProductAndServicesUrlPublic()
  }, {
    questionKey: 'cmsHub.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.OPERATIONS]: [{
    questionKey: 'operations.whatIsOperationsHub',
    getHref: () => getOperationsUrlPublic()
  }, {
    questionKey: 'operations.whatSupport',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'operations.whatDoesDataSyncDo',
    isJSX: false
  }, {
    questionKey: 'operations.whatTypeOfDataSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatApplicationsSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatIsProgrammableAutomation',
    isJSX: false
  }, {
    questionKey: 'operations.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.FREE]: [{
    questionKey: 'free.crmReallyFree411'
  }, {
    questionKey: 'free.whatAreLimits411',
    getHref: () => getProductAndServicesUrlPublic()
  }, {
    questionKey: 'free.emailIntegration411'
  }, {
    questionKey: 'free.whatIsAUser411'
  }, {
    questionKey: 'free.howManyContacts411'
  }, {
    questionKey: 'free.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }, {
    questionKey: 'free.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    })
  }],
  [NavItemEnum.SUITE]: [{
    questionKey: 'crmSuite.whatIsCrmSuite',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }]
};